import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from 'src/environments/environment';

@Injectable()
export class JurisdictionService {

  constructor(private _http: HttpClient) { }

  getLanguageList(): any {
    return this._http.get(environment.APIEndpoint + 'api/Language/GetLanguageList')
      .map((res) => res)
      .catch(this._errorHandler);
  }


  getAllJurisdictionList(): any {
    return this._http.get(environment.APIEndpoint + 'api/Jurisdiction/GetAllJurisdictionList')
      .map((res) => res)
      .catch(this._errorHandler);
  }

  addJurisdictionList(mappedRoles: any) {
    // const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this._http.post(environment.APIEndpoint + 'api/Jurisdiction/AddJurisdictionList', mappedRoles)
      .map((res: Response) => res);
  }

  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }

  deleteJurisdiction(jurisdictionMappingId: any): any {
    return this._http.delete(environment.APIEndpoint + 'api/Jurisdiction/DeleteJurisdiction?mappingId=' + jurisdictionMappingId)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getJurisdictionDropDown(languageId: number): Observable<any> {
    return this._http.get(environment.APIEndpoint + 'api/Jurisdiction/GetJurisdictionLoadDropdown?languageId=' + languageId)
      .map((data) => data).catch(this._errorHandler);
  }
}

